import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { AlertModal } from '@src/components/Modal/AlertModal'
import {
  OutletFulfilmentStateType,
  useOutletFulfilment,
} from '@src/hooks/outletFulfilmentAndBasketHooks/useOutletFulfilment/useOutletFulfilment'
import { useMarketplace } from '@src/hooks/useMarketplace'

// OutletClosedAlert is open when a `message` is passed, and closed when it is undefined
export const OutletClosedAlert: React.FC<{
  message?: string
}> = ({ message }) => {
  const marketplace = useMarketplace()
  const { outlet } = useOutletFulfilment({
    stateType: OutletFulfilmentStateType.GLOBAL,
  })
  const { t } = useTranslation('dirtyBasket')
  const navigate = useNavigate()

  return (
    <AlertModal
      isOpen={message !== undefined}
      title={message as string}
      action={{
        text: t(`view_outlet_list`),
        onClick: () => {
          navigate(`/${marketplace.urlPath}`)
        },
      }}
      cancel={{
        text: t(`view_outlet_menu`, { restaurantName: outlet.restaurant.name }),
        onClick: () => {
          navigate(
            `/${marketplace.urlPath}/${outlet.id}/${outlet.restaurant.name}`
          )
        },
      }}
    />
  )
}
